import { forwardRef } from 'react';
import { node } from 'prop-types';
import clsx from 'clsx';

import useStyles from './MenuStyles';

const Menu = forwardRef(({ children, className }, ref) => {
    const classes = useStyles();

    return (
        <div ref={ref} className={clsx(classes.root, className)}>
            {children}
        </div>
    );
});

Menu.propTypes = {
    children: node.isRequired,
};

export default Menu;
